/**
 * Utility function to handle API calls with centralized error handling.
 * @param promise - The API call promise.
 * @returns The result of the API call, or null if an error occurred.
 */
export const apiCall = async <T>(promise: Promise<T>): Promise<T | null> => {
    try {
        return await promise;
    } catch (error) {
        console.error("API error:", error);
        return null;
    }
};
